const initialState = {
}

const misc = (state = initialState) => {
  return state
}

export default misc
